module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/housekeeping/css/preferences.component.css
// module id = ./src/app/modules/housekeeping/css/preferences.component.css
// module chunks = main